// extracted by mini-css-extract-plugin
export default {"imgdiv":"bccd3d95cf _375462ec26","img":"_3701ad4e45 bda062e9be"};